import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'
import {Checkbox} from 'primereact/checkbox'
import {InputSwitch} from 'primereact/inputswitch'
import {InputText} from 'primereact/inputtext'
import {RadioButton} from 'primereact/radiobutton'
import {Tag} from 'primereact/tag'
import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useMemo,
    useRef,
} from 'react'
import TranslateUtils from '../../../i18n/TranslateUtils'
import CodeConfig from '../../client/CodeConfig'
import {component} from '../../form/Constant'
import ImageUploader from '../../image/ImageUploader'
import StyledDropdown from '../components/StyledDropdown'
import StyledInput from '../components/StyledInput'
import StyledInputMask from '../components/StyledInputMask'
import StyledAddressInformationUtils from './StyledAddressInformationUtils'
import StyledGeneralPractitionerUtils from './StyledGeneralPractitionerUtils'

const StyledDetailInformationSection = forwardRef(
    (
        {
            data = {},
            dataList = [],
            hideLockButton = false,
            hideRevertButton = false,
            onSubmit = () => {},
        },
        ref,
    ) => {
        useImperativeHandle(ref, () => ({
            onSuccess: handleOnSuccess,
        }))
        useSignals()

        //#region Translate
        const {translateCommons} = TranslateUtils()
        //#endregion

        //#region State
        const infoData = useMemo(() => {
            if (!data || !data?.id) {
                return {}
            }

            return data
        }, [data])

        const formData = useSignal({})

        const handleOnSuccess = () => {
            isLock.value = true
        }

        useEffect(() => {
            if (infoData && infoData?.id) {
                formData.value =
                    infoData && Object.keys(infoData)?.length > 0
                        ? {...infoData}
                        : {}
            }
        }, [infoData])

        const isChangedValue = useSignal(false)
        const isLock = useSignal(true)
        const codeConfigRef = useRef(null)
        //#endregion

        const handleOnSubmit = () => {
            // if (!isChangedValue.value) {
            //     return
            // }

            let toPostData
            let codeConfigData

            if (codeConfigRef.current && codeConfigRef.current.getValue) {
                codeConfigData = {
                    codeConfig: codeConfigRef.current.getValue(),
                }
            }

            if (codeConfigData) {
                toPostData = {
                    ...formData.value,
                    ...codeConfigData,
                }
            } else {
                toPostData = {
                    ...formData.value,
                }
            }

            if (onSubmit) {
                onSubmit(toPostData)
            }
        }

        const handleOnChange = (key, value) => {
            if (!isChangedValue.value) {
                isChangedValue.value = true
            }

            formData.value = {...formData.value, [key]: value}
        }

        const handleOnChangeCheckbox = (key, value) => {
            if (!isChangedValue.value) {
                isChangedValue.value = true
            }

            if (!value) {
                return
            }

            if (!formData.value) {
                formData.value = {
                    [key]: [value],
                }

                return
            }

            if (!formData.value[key] || !formData.value[key]?.length) {
                formData.value = {
                    ...formData.value,
                    [key]: [value],
                }
                return
            }

            if (!formData.value[key].includes(value)) {
                formData.value = {
                    ...formData.value,
                    [key]: [...formData.value[key], value],
                }
            } else {
                let filterList = formData.value[key]?.filter(
                    item => item !== value,
                )
                formData.value = {
                    ...formData.value,
                    [key]: [...filterList],
                }
            }
        }

        const handleAddressOnChange = value => {
            if (!isChangedValue.value) {
                isChangedValue.value = true
            }
            formData.value = {...formData.value, ...value}
        }

        const handleEditForm = () => {
            if (!isLock.value && isChangedValue.value) {
                handleOnSubmit()
            } else {
                isLock.value = !isLock.value
            }
            // if (!isLock.value) {
            //     handleOnSubmit()
            // }
            // isLock.value = !isLock.value
        }

        const handleOnUndo = () => {
            formData.value = {...data}
            isChangedValue.value = false
        }

        return (
            <React.Fragment>
                {dataList?.length &&
                    dataList?.map((item, index) => (
                        <div
                            key={item?.key + '-' + index}
                            className="col-12 p-0">
                            <div className="flex mb-1 border-round justify-content-between align-items-center  px-2 py-3 flex-wrap bg-teal-50 ">
                                <h5
                                    className={`pl-2 text-darkcyan m-0 font-bold text-center py-2 md:text-left`}>
                                    <span className="mr-3">
                                        {item?.icon &&
                                            (typeof item?.icon === 'string' ? (
                                                <i
                                                    className={`${item.icon} font-bold text-xl`}></i>
                                            ) : (
                                                item?.icon
                                            ))}
                                    </span>

                                    {translateCommons(item?.label)}
                                </h5>
                                <div className="flex">
                                    {/* {isChangedValue.value && (
                                        <Button
                                            icon={'pi pi-undo'}
                                            className="p-button-outlined mr-2"
                                            onClick={handleOnUndo}
                                        />
                                    )} */}
                                    <Button
                                        label={`${
                                            isLock.value ? 'Edit' : 'Save'
                                        }`}
                                        icon={`${
                                            isLock.value
                                                ? 'pi pi-pencil'
                                                : 'pi pi-save'
                                        }`}
                                        className="p-button-outlined mr-2"
                                        onClick={handleEditForm}
                                    />
                                </div>
                            </div>
                            <div className="col-12 grid align-items-stretch pt-3 px-0">
                                {item.children?.map((children, index) => (
                                    <div
                                        key={children?.key + index}
                                        className={`${
                                            children?.col
                                                ? children?.col
                                                : 'col-12  md:col-4 '
                                        }`}>
                                        <div className="mb-2">
                                            {/* Component Header */}
                                            {children.component !==
                                                component.address &&
                                                children.component !==
                                                    component.generalPractitioner &&
                                                !children?.hideHeader && (
                                                    <div className="flex align-items-center justify-content-between">
                                                        <div>
                                                            <h6 className="text-600 mb-2 font-bold">
                                                                {
                                                                    children?.label
                                                                }
                                                            </h6>
                                                        </div>

                                                        <div>
                                                            {children?.required && (
                                                                <Tag
                                                                    value={
                                                                        'This field is required !'
                                                                    }
                                                                    severity="danger"
                                                                    icon="pi pi-info-circle"></Tag>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            {/* End Region */}

                                            {/* Children Component */}
                                            {/* Input Text */}
                                            {children?.component ===
                                                component.inputText &&
                                                (!!isLock.value ? (
                                                    <InputText
                                                        className="w-full h-3rem"
                                                        value={
                                                            formData.value[
                                                                children?.key
                                                            ] || 'Unknown'
                                                        }
                                                        disabled={true}
                                                    />
                                                ) : (
                                                    <StyledInput
                                                        value={
                                                            formData.value[
                                                                children?.key
                                                            ] || ''
                                                        }
                                                        placeholder={
                                                            children?.placeholder
                                                        }
                                                        onChange={newValue => {
                                                            handleOnChange(
                                                                children.key,
                                                                newValue,
                                                            )
                                                        }}
                                                    />
                                                ))}

                                            {/* Dropdown */}
                                            {children?.component ===
                                                component.dropdown &&
                                                (!!isLock.value ? (
                                                    <InputText
                                                        className="w-full h-3rem"
                                                        value={
                                                            children?.options
                                                                ?.length
                                                                ? children?.options.find(
                                                                      item =>
                                                                          item?.value ===
                                                                          formData
                                                                              .value[
                                                                              children
                                                                                  ?.key
                                                                          ],
                                                                  )?.label ||
                                                                  children?.options.find(
                                                                      item =>
                                                                          item?.value ===
                                                                          children?.defaultValue,
                                                                  )?.label ||
                                                                  'Unknown'
                                                                : 'Unknown'
                                                        }
                                                        disabled={true}
                                                    />
                                                ) : (
                                                    <StyledDropdown
                                                        value={
                                                            formData.value[
                                                                children?.key
                                                            ] ||
                                                            children?.defaultValue ||
                                                            null
                                                        }
                                                        options={
                                                            children?.options ||
                                                            []
                                                        }
                                                        onChange={newValue => {
                                                            handleOnChange(
                                                                children.key,
                                                                newValue,
                                                            )
                                                        }}
                                                    />
                                                ))}

                                            {/* Input Mask */}
                                            {children?.component ===
                                                component.inputMask &&
                                                (!!isLock.value ? (
                                                    <InputText
                                                        className="w-full h-3rem"
                                                        value={
                                                            formData.value[
                                                                children?.key
                                                            ] || 'Unknown'
                                                        }
                                                        disabled={true}
                                                    />
                                                ) : (
                                                    <StyledInputMask
                                                        value={
                                                            formData.value[
                                                                children?.key
                                                            ] || ''
                                                        }
                                                        placeholder={
                                                            children?.placeholder
                                                        }
                                                        onChange={newValue => {
                                                            handleOnChange(
                                                                children.key,
                                                                newValue,
                                                            )
                                                        }}
                                                    />
                                                ))}

                                            {/* Address */}
                                            {children?.component ===
                                                component.address && (
                                                <StyledAddressInformationUtils
                                                    shouldTextBold={true}
                                                    data={formData.value}
                                                    onChange={newValue => {
                                                        handleAddressOnChange(
                                                            newValue,
                                                        )
                                                    }}
                                                    isLock={!!isLock.value}
                                                />
                                            )}

                                            {/* General Practitioner */}
                                            {children?.component ===
                                                component.generalPractitioner && (
                                                <StyledGeneralPractitionerUtils
                                                    shouldTextBold={true}
                                                    isLock={isLock.value}
                                                    data={formData.value}
                                                    className={
                                                        item.className
                                                            ? item.className
                                                            : ''
                                                    }
                                                    childrenClassName={
                                                        item.childrenClassName
                                                            ? item.childrenClassName
                                                            : ''
                                                    }
                                                    onChange={newValue => {
                                                        handleOnChange(
                                                            'generalPractitioner',
                                                            newValue,
                                                        )
                                                    }}
                                                    defaultValue={
                                                        item.initialValue
                                                            ? item.initialValue
                                                            : {}
                                                    }
                                                />
                                            )}

                                            {/* Code Configuration */}
                                            {children?.component ===
                                                component.codeConfiguration && (
                                                <CodeConfig
                                                    ref={codeConfigRef}
                                                    isLock={isLock.value}
                                                    defaultValue={
                                                        formData.value[
                                                            'codeConfig'
                                                        ] || {}
                                                    }
                                                    changedValue={() => {
                                                        isChangedValue.value =
                                                            !isChangedValue.value
                                                    }}
                                                />
                                            )}

                                            {/* Image Uploader */}
                                            {children?.component ===
                                                component.fileUpload && (
                                                <div className="col-12 px-0  mb-3">
                                                    <ImageUploader
                                                        id={'image'}
                                                        ref={null}
                                                        callBack={() => {}}
                                                        multiple={false}
                                                        extraData={{}}
                                                    />
                                                </div>
                                            )}

                                            {/* Toggle Button */}
                                            {children?.component ===
                                                component.toggleButton && (
                                                <div className="flex flex-column align-items-start mb-3">
                                                    <div className="flex justify-content-between align-items-center mb-2">
                                                        <div className="flex align-items-center">
                                                            <div
                                                                className="mr-3"
                                                                style={{
                                                                    height: '24px',
                                                                    width: '24px',
                                                                }}>
                                                                {children.icon}
                                                            </div>
                                                            <div>
                                                                <h5 className="mb-0 font-semibold">
                                                                    {
                                                                        children?.label
                                                                    }
                                                                </h5>
                                                            </div>
                                                        </div>
                                                        <div className="ml-5">
                                                            <InputSwitch
                                                                checked={
                                                                    formData
                                                                        .value[
                                                                        children
                                                                            .key
                                                                    ]
                                                                }
                                                                disabled={
                                                                    isLock.value
                                                                }
                                                                className={
                                                                    children.className
                                                                        ? children.className
                                                                        : ''
                                                                }
                                                                onChange={e =>
                                                                    handleOnChange(
                                                                        children.key,
                                                                        e.value,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <span>
                                                        {children?.description}
                                                    </span>
                                                </div>
                                            )}

                                            {/* Radio Button */}
                                            {children?.component ===
                                                component.radioButton && (
                                                <div className="flex flex-column align-items-start mb-3">
                                                    <div className="flex align-items-center mb-2">
                                                        <div className="flex align-items-center mr-3">
                                                            <div
                                                                className="mr-3"
                                                                style={{
                                                                    height: '24px',
                                                                    width: '24px',
                                                                }}>
                                                                {children.icon}
                                                            </div>
                                                            <div>
                                                                <h5 className="mb-0 font-semibold">
                                                                    {
                                                                        children?.label
                                                                    }
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span className="mb-2">
                                                        {children?.description}
                                                    </span>
                                                    <div className="flex">
                                                        {children?.options?.map(
                                                            (option, idx) => (
                                                                <div
                                                                    key={idx}
                                                                    className={`flex align-items-center justify-content-between m-2 p-2 border-round border-2  ${
                                                                        formData
                                                                            .value[
                                                                            children
                                                                                .key
                                                                        ] ===
                                                                        option?.value
                                                                            ? 'border-primary text-primary'
                                                                            : 'border-400'
                                                                    } ${
                                                                        isLock.value
                                                                            ? 'select-none surface-50'
                                                                            : 'select-auto cursor-pointer'
                                                                    }`}
                                                                    onClick={() =>
                                                                        !isLock.value &&
                                                                        handleOnChange(
                                                                            children.key,
                                                                            option.value,
                                                                        )
                                                                    }>
                                                                    <div className="flex align-items-center mr-5">
                                                                        {
                                                                            option?.icon
                                                                        }
                                                                        <label
                                                                            htmlFor={
                                                                                children?.key
                                                                            }
                                                                            className={`mx-2 ${
                                                                                isLock.value
                                                                                    ? 'select-none'
                                                                                    : 'select-auto cursor-pointer'
                                                                            }`}>
                                                                            {
                                                                                option?.label
                                                                            }
                                                                        </label>
                                                                    </div>

                                                                    <RadioButton
                                                                        inputId={
                                                                            option?.value
                                                                        }
                                                                        name={
                                                                            children?.key
                                                                        }
                                                                        value={
                                                                            option?.value
                                                                        }
                                                                        disabled={
                                                                            isLock.value
                                                                        }
                                                                        checked={
                                                                            formData
                                                                                .value[
                                                                                children
                                                                                    .key
                                                                            ] &&
                                                                            formData
                                                                                .value[
                                                                                children
                                                                                    .key
                                                                            ] ===
                                                                                option?.value
                                                                        }
                                                                    />
                                                                </div>
                                                            ),
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            {/* Multi Checkbox */}
                                            {children.component ===
                                                component.multiCheckbox && (
                                                <div className="flex flex-column align-items-start mb-3">
                                                    <div className="flex align-items-center mb-2">
                                                        <div className="flex align-items-center mr-3">
                                                            <div
                                                                className="mr-3"
                                                                style={{
                                                                    height: '24px',
                                                                    width: '24px',
                                                                }}>
                                                                {children.icon}
                                                            </div>
                                                            <div>
                                                                <h5 className="mb-0 font-semibold">
                                                                    {
                                                                        children?.label
                                                                    }
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span className="mb-2">
                                                        {children?.description}
                                                    </span>
                                                    <div className="flex">
                                                        {children?.options?.map(
                                                            option => (
                                                                <div
                                                                    className={`flex align-items-center justify-content-between m-2 p-2 border-round border-2 ${
                                                                        formData
                                                                            .value[
                                                                            children
                                                                                .key
                                                                        ] &&
                                                                        formData.value[
                                                                            children
                                                                                .key
                                                                        ].includes(
                                                                            option?.value,
                                                                        )
                                                                            ? 'border-primary text-primary'
                                                                            : 'border-400'
                                                                    } ${
                                                                        isLock.value
                                                                            ? 'select-none surface-50'
                                                                            : 'select-auto cursor-pointer'
                                                                    }`}
                                                                    onClick={() =>
                                                                        !isLock.value &&
                                                                        handleOnChangeCheckbox(
                                                                            children.key,
                                                                            option.value,
                                                                        )
                                                                    }>
                                                                    <div className="flex align-items-center mr-5">
                                                                        {
                                                                            option?.icon
                                                                        }
                                                                        <label
                                                                            htmlFor={
                                                                                children?.key
                                                                            }
                                                                            className={`mx-2 ${
                                                                                isLock.value
                                                                                    ? 'select-none'
                                                                                    : 'select-auto cursor-pointer'
                                                                            }`}>
                                                                            {
                                                                                option?.label
                                                                            }
                                                                        </label>
                                                                    </div>

                                                                    <Checkbox
                                                                        inputId={
                                                                            option?.value
                                                                        }
                                                                        name={
                                                                            children?.key
                                                                        }
                                                                        value={
                                                                            option?.value
                                                                        }
                                                                        disabled={
                                                                            isLock.value
                                                                        }
                                                                        checked={
                                                                            formData
                                                                                .value[
                                                                                children
                                                                                    .key
                                                                            ] &&
                                                                            formData.value[
                                                                                children
                                                                                    .key
                                                                            ].includes(
                                                                                option?.value,
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            ),
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            {/* End Region */}

                                            {/* Description */}
                                            {children?.description &&
                                                !children?.hideDescription &&
                                                (typeof children?.description ===
                                                'string' ? (
                                                    <p>
                                                        {children?.description}
                                                    </p>
                                                ) : (
                                                    children?.description
                                                ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
            </React.Fragment>
        )
    },
)

export default StyledDetailInformationSection
